import { CurrencyCode, toEnum } from 'corso-types';

export const toCurrencyCode = (code: string) => {
  try {
    return toEnum(code, CurrencyCode);
  } catch {
    return CurrencyCode.USD;
  }
};
